<template>
  <a-drawer width="60%" :visible="open" @cancel="onClose" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :model="form" :rules="rules" :label-col="labelCol" :wrapper-col="wrapperCol">
      <a-form-model-item :label="$t('云种植种子.种子名称')" prop="seedName">
        <a-input v-model="form.seedName" :maxLength="100" :placeholder="$t('通用.输入.请输入') + $t('云种植种子.种子名称')" />
      </a-form-model-item>

      <a-form-model-item :label="$t('云种植种子.种子图片')" prop="seedImage">
        <OssUploadSingle v-model="form.seedImage" type="img" :maxSize="200"></OssUploadSingle>
      </a-form-model-item>

      <a-form-model-item :label="$t('云种植种子.所属气候')" prop="climateId">
        <a-select v-model="form.climateId" :placeholder="$t('通用.输入.请选择') + $t('云种植种子.所属气候')">
          <a-select-option v-for="item in climateList" :value="item.id" :key="item.id">
            {{ item.climateName }}
          </a-select-option>
        </a-select>
      </a-form-model-item>

      <a-form-model-item :label="$t('云种植种子.种子价格')" prop="price">
        <a-input-number v-model="form.price" :min="0" :precision="2" style="width: 200px" />
      </a-form-model-item>

      <a-form-model-item :label="$t('云种植种子.温馨提示')" prop="tips">
        <a-textarea v-model="form.tips" :maxLength="500" :rows="3" :placeholder="$t('通用.输入.请输入') + $t('云种植种子.温馨提示')" allow-clear />
      </a-form-model-item>

      <a-form-model-item :label="$t('云种植种子.状态')" prop="status">
        <a-radio-group v-model="form.status">
          <a-radio v-for="(item, index) in customDict.OnOffEnum" :key="index" :value="item.type">
            {{ item.name }}
          </a-radio>
        </a-radio-group>
      </a-form-model-item>

      <a-form-model-item :label="$t('云种植种子.排序')" prop="sort">
        <a-input-number v-model="form.sort" :min="0" :max="9999" style="width: 200px" />
      </a-form-model-item>

      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">{{ $t('通用.按钮.保存') }}</a-button>
          <a-button @click="cancel">{{ $t('通用.按钮.取消') }}</a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import { getSeed, addSeed, updateSeed } from '@/api/cloudplant/seed'
import { listClimate } from '@/api/cloudplant/climate'
import OssUploadSingle from '@/components/OssUploadSingle'
import { mapGetters } from 'vuex'

export default {
  name: 'CreateForm',
  components: { OssUploadSingle },
  data() {
    return {
      labelCol: { span: 4 },
      wrapperCol: { span: 16 },
      submitLoading: false,
      formTitle: '',
      open: false,
      formType: 1,
      climateList: [],
      form: {
        id: null,
        seedName: null,
        seedImage: null,
        climateId: undefined,
        price: 0,
        tips: null,
        status: 1,
        sort: 0
      },
      rules: {
        seedName: [{ required: true, message: this.$t('云种植种子.种子名称') + this.$t('通用.文本.不能为空'), trigger: 'blur' }],
        climateId: [{ required: true, message: this.$t('云种植种子.所属气候') + this.$t('通用.文本.不能为空'), trigger: 'change' }]
      }
    }
  },
  computed: {
    ...mapGetters(['customDict'])
  },
  created() {
    this.getClimateList()
  },
  methods: {
    getClimateList() {
      listClimate({}).then(response => {
        this.climateList = response.data
      })
    },
    onClose() {
      this.open = false
      this.reset()
    },
    cancel() {
      this.open = false
      this.reset()
    },
    reset() {
      this.formType = 1
      this.form = {
        id: null,
        seedName: null,
        seedImage: null,
        climateId: undefined,
        price: 0,
        tips: null,
        status: 1,
        sort: 0
      }
    },
    handleAdd() {
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = this.$t('通用.文本.添加')
    },
    handleUpdate(row) {
      this.reset()
      this.formType = 2
      getSeed({ id: row.id }).then(response => {
        this.form = response.data
        this.open = true
        this.formTitle = this.$t('通用.文本.修改')
      })
    },
    submitForm() {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          if (this.form.id) {
            updateSeed(this.form)
              .then(() => {
                this.$message.success(this.$t('通用.文本.修改成功'))
                this.open = false
                this.$emit('ok')
              })
              .finally(() => {
                this.submitLoading = false
              })
          } else {
            addSeed(this.form)
              .then(() => {
                this.$message.success(this.$t('通用.文本.新增成功'))
                this.open = false
                this.$emit('ok')
              })
              .finally(() => {
                this.submitLoading = false
              })
          }
        }
      })
    }
  }
}
</script>
